import React, {useState} from 'react'
import {InvisibleButton, StyledCard, StyledIFrame, StyledModal,} from './FooterModal.styled'
import PropTypes from 'prop-types'

const IdIframe = 'idIframe'
const Frameborder = '0'
const Scrolling = 'yes'
const Marginheight = '0'
const Marginwidth = '0'
const Type = 'text/javascript'
const ScriptUrl = 'https://app.mailjet.com/statics/js/iframeResizer.min.js'

const FooterModal = ({show, onClose, isMobile}) => {
  const url = isMobile
    ? 'https://xqrpp.mjt.lu/wgt/xqrpp/vs6/form?c=dd844906'
    : 'https://xqrpp.mjt.lu/wgt/xqrpp/vs6/form?c=dd844906'
  const [tmp, setTmp] = useState(false)
  if (!show) {
    return null
  }
  return (
    <StyledModal
      onClick={() => {
        setTmp(false)
        return onClose()
      }}
    >
      <StyledCard>
        <StyledIFrame
          id={IdIframe}
          frameborder={Frameborder}
          scrolling={Scrolling}
          marginheight={Marginheight}
          marginwidth={Marginwidth}
          onLoad={() => setTmp(true)}
          src={url}
        />
        {/* Invisible button on top of Iframe to close modal */}
        {/* <InvisibleButton
          onClick={() => {
            setTmp(false)
            return onClose()
          }}
        /> */}
      </StyledCard>
      <script type={Type} src={ScriptUrl}></script>
    </StyledModal>
  )
}

FooterModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
}

export default FooterModal
